import Dashboard from "views/Dashboard";
import Login from "views/Login";
import OrganizationList from "views/Organizations/OrganizationList";
import OrganizationDetails from "views/Organizations/OrganizationDetails";
import OrganizationAdd from "views/Organizations/OrganizationAdd";
import MainTemplate from "components/templates/MainTemplate";
import VenueList from "views/Venues/VenueList";
import OrganizationEdit from "views/Organizations/OrganizationEdit";
import VenueAdd from "views/Venues/VenueAdd";
import VenueEdit from "views/Venues/VenueEdit";
import AuthAccessibility from "components/common/AuthAccessibility";
import { AuthAccessibilityType } from "components/common/AuthAccessibility/enums";
import Settings from "views/Settings";
import VenueDetails from "views/Venues/VenueDetails";
import Payment from "views/Settings/Tabs/Payment";
import UsersList from "views/Settings/Tabs/Users/UserList";
import UserAdd from "views/Settings/Tabs/Users/UserAdd";
import UserEdit from "views/Settings/Tabs/Users/UserEdit";
import UserDetails from "views/Settings/Tabs/Users/UserDetails";
import VenueLogin from "views/Venues/VenueLogin";
import PaymentTerminalList from "views/Settings/Tabs/PaymentTerminals/PaymentTerminalList";
import PaymentTerminalAdd from "views/Settings/Tabs/PaymentTerminals/PaymentTerminalAdd";
import VenueUserList from "views/Settings/Tabs/VenueUsers/VenueUserList";
import VenueUserCreate from "views/Settings/Tabs/VenueUsers/VenueUserCreate";
import VenueUserEdit from "views/Settings/Tabs/VenueUsers/VenueUserEdit";
import RecuringEvents from "views/RecuringEvents";
import Events from "views/Events";
import NewEvent from "views/Events/New";
import EventList from "views/Events/EventList";
import TicketTemplateList from "views/TicketTemplates/TicketTemplateList";
import TicketTemplateCreate from "views/TicketTemplates/TicketTemplateCreate";
import TicketTemplateEdit from "views/TicketTemplates/TicketTemplateEdit";
import DiscountCodeList from "views/DiscountCodes/DiscountCodeList";
import DiscountCodeCreate from "views/DiscountCodes/DiscountCodeCreate";
import DiscountCodeEdit from "views/DiscountCodes/DiscountCodeEdit";
import EventDetails from "views/Events/EventDetails";
import EditEvent from "views/Events/EventEdit";
import Embed from "views/Settings/Tabs/Embed";
import OrderList from "views/Orders/OrderList";
import OrderDetails from "views/Orders/OrderDetails";
import NewRecuringEvent from "views/RecuringEvents/New";
import RecuringEventList from "views/RecuringEvents/RecuringEventList";
import RecuringEventDetails from "views/RecuringEvents/RecuringEventDetails";

import { ROUTE_PATHS } from "./paths";

const routes = [
  {
    path: ROUTE_PATHS.Dashboard,
    element: (
      <AuthAccessibility authAccessibility={AuthAccessibilityType.onlyLoggedIn}>
        <MainTemplate>
          <Dashboard />
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.Login,
    element: (
      <AuthAccessibility
        authAccessibility={AuthAccessibilityType.onlyNotLoggedIn}
      >
        <Login />
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.OrganizationsList,
    element: (
      <AuthAccessibility authAccessibility={AuthAccessibilityType.onlyLoggedIn}>
        <MainTemplate>
          <OrganizationList />
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.OrganizationCreate,
    element: (
      <AuthAccessibility authAccessibility={AuthAccessibilityType.onlyLoggedIn}>
        <MainTemplate>
          <OrganizationAdd />
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.OrganizationDetails,
    element: (
      <AuthAccessibility authAccessibility={AuthAccessibilityType.onlyLoggedIn}>
        <MainTemplate>
          <OrganizationDetails />
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.OrganizationEdit,
    element: (
      <AuthAccessibility authAccessibility={AuthAccessibilityType.onlyLoggedIn}>
        <MainTemplate>
          <OrganizationEdit />
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.Events,
    element: (
      <AuthAccessibility authAccessibility={AuthAccessibilityType.onlyLoggedIn}>
        <MainTemplate>
          <Events />
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.EventCreate,
    element: (
      <AuthAccessibility authAccessibility={AuthAccessibilityType.onlyLoggedIn}>
        <MainTemplate>
          <NewEvent />
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.EventList,
    element: (
      <AuthAccessibility authAccessibility={AuthAccessibilityType.onlyLoggedIn}>
        <MainTemplate>
          <EventList />
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.RecuringEvents,
    element: (
      <AuthAccessibility authAccessibility={AuthAccessibilityType.onlyLoggedIn}>
        <MainTemplate>
          <RecuringEvents />
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.RecuringEventCreate,
    element: (
      <AuthAccessibility authAccessibility={AuthAccessibilityType.onlyLoggedIn}>
        <MainTemplate>
          <NewRecuringEvent />
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.RecuringEventList,
    element: (
      <AuthAccessibility authAccessibility={AuthAccessibilityType.onlyLoggedIn}>
        <MainTemplate>
          <RecuringEventList />
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.VenuesList,
    element: (
      <AuthAccessibility authAccessibility={AuthAccessibilityType.onlyLoggedIn}>
        <MainTemplate>
          <VenueList />
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.VenuesCreate,
    element: (
      <AuthAccessibility authAccessibility={AuthAccessibilityType.onlyLoggedIn}>
        <MainTemplate>
          <VenueAdd />
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.VenueEdit,
    element: (
      <AuthAccessibility authAccessibility={AuthAccessibilityType.onlyLoggedIn}>
        <MainTemplate>
          <VenueEdit />
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.VenueDetails,
    element: (
      <AuthAccessibility authAccessibility={AuthAccessibilityType.onlyLoggedIn}>
        <MainTemplate>
          <VenueDetails />
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.SettingsUsers,
    element: (
      <AuthAccessibility authAccessibility={AuthAccessibilityType.onlyLoggedIn}>
        <MainTemplate>
          <Settings>
            <UsersList />
          </Settings>
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.SettingsUsers,
    element: (
      <AuthAccessibility authAccessibility={AuthAccessibilityType.onlyLoggedIn}>
        <MainTemplate>
          <Settings>
            <UsersList />
          </Settings>
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.SettingsVenueUserList,
    element: (
      <AuthAccessibility
        authAccessibility={AuthAccessibilityType.onlyVenueSelected}
      >
        <MainTemplate>
          <Settings>
            <VenueUserList />
          </Settings>
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.SettingsVenueUserCreate,
    element: (
      <AuthAccessibility
        authAccessibility={AuthAccessibilityType.onlyVenueSelected}
      >
        <MainTemplate>
          <VenueUserCreate />
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.SettingsVenueUserEdit,
    element: (
      <AuthAccessibility
        authAccessibility={AuthAccessibilityType.onlyVenueSelected}
      >
        <MainTemplate>
          <VenueUserEdit />
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.SettingsUsersCreate,
    element: (
      <AuthAccessibility authAccessibility={AuthAccessibilityType.onlyLoggedIn}>
        <MainTemplate>
          <UserAdd />
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.SettingsUserEdit,
    element: (
      <AuthAccessibility authAccessibility={AuthAccessibilityType.onlyLoggedIn}>
        <MainTemplate>
          <UserEdit />
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.SettingsUserDetails,
    element: (
      <AuthAccessibility authAccessibility={AuthAccessibilityType.onlyLoggedIn}>
        <MainTemplate>
          <UserDetails />
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.SettingsPayments,
    element: (
      <AuthAccessibility authAccessibility={AuthAccessibilityType.onlyLoggedIn}>
        <MainTemplate>
          <Settings>
            <Payment />
          </Settings>
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.PaymentTerminalsList,
    element: (
      <AuthAccessibility
        authAccessibility={AuthAccessibilityType.onlyVenueSelected}
      >
        <MainTemplate>
          <Settings>
            <PaymentTerminalList />
          </Settings>
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.Embed,
    element: (
      <AuthAccessibility
        authAccessibility={AuthAccessibilityType.onlyVenueSelected}
      >
        <MainTemplate>
          <Settings>
            <Embed />
          </Settings>
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.PaymentTerminalCreate,
    element: (
      <AuthAccessibility
        authAccessibility={AuthAccessibilityType.onlyVenueSelected}
      >
        <MainTemplate>
          <PaymentTerminalAdd />
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.VenueLogin,
    element: (
      <AuthAccessibility authAccessibility={AuthAccessibilityType.onlyLoggedIn}>
        <VenueLogin />
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.TicketTemplateList,
    element: (
      <AuthAccessibility
        authAccessibility={AuthAccessibilityType.onlyVenueSelected}
      >
        <MainTemplate>
          <TicketTemplateList />
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.TicketTemplateCreate,
    element: (
      <AuthAccessibility
        authAccessibility={AuthAccessibilityType.onlyVenueSelected}
      >
        <MainTemplate>
          <TicketTemplateCreate />
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.TicketTemplateEdit,
    element: (
      <AuthAccessibility
        authAccessibility={AuthAccessibilityType.onlyVenueSelected}
      >
        <MainTemplate>
          <TicketTemplateEdit />
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.DiscountCodeList,
    element: (
      <AuthAccessibility
        authAccessibility={AuthAccessibilityType.onlyVenueSelected}
      >
        <MainTemplate>
          <DiscountCodeList />
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.DiscountCodeCreate,
    element: (
      <AuthAccessibility
        authAccessibility={AuthAccessibilityType.onlyVenueSelected}
      >
        <MainTemplate>
          <DiscountCodeCreate />
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.DiscountCodeEdit,
    element: (
      <AuthAccessibility
        authAccessibility={AuthAccessibilityType.onlyVenueSelected}
      >
        <MainTemplate>
          <DiscountCodeEdit />
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.EventDetails,
    element: (
      <AuthAccessibility
        authAccessibility={AuthAccessibilityType.onlyVenueSelected}
      >
        <MainTemplate>
          <EventDetails />
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.EventEdit,
    element: (
      <AuthAccessibility
        authAccessibility={AuthAccessibilityType.onlyVenueSelected}
      >
        <MainTemplate>
          <EditEvent />
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.RecuringEventDetails,
    element: (
      <AuthAccessibility
        authAccessibility={AuthAccessibilityType.onlyVenueSelected}
      >
        <MainTemplate>
          <RecuringEventDetails />
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.OrderList,
    element: (
      <AuthAccessibility
        authAccessibility={AuthAccessibilityType.onlyVenueSelected}
      >
        <MainTemplate>
          <OrderList />
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
  {
    path: ROUTE_PATHS.OrderRead,
    element: (
      <AuthAccessibility
        authAccessibility={AuthAccessibilityType.onlyVenueSelected}
      >
        <MainTemplate>
          <OrderDetails />
        </MainTemplate>
      </AuthAccessibility>
    ),
  },
];

export default routes;
